import React from 'react';
import styled from 'styled-components';
import Popup from '../../../Plateforme/Atoms/Popup';
import { useNavigate } from 'react-router-dom';

const AddProfilePopup = styled.div`
    position: absolute;
    top: 200px;
    width: 720px;
    background-color: white;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 0 30px 0 rgba(0,0,0,0.2);
`

const MiniaturesContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .portfolio img{
        height: 100px;
        margin-right: 10px;
        width: auto;
    }
`

const DesignersList = (props) => {

    const navigate = useNavigate();

    const [addingProfile, setAddingProfile] = React.useState(false);
    const [manualProfile, setManualProfile] = React.useState({eventId: props.event._id, eventType: props.event.type, shortlistId: props.shortlistid});

    async function addProfile(e) {
        e.preventDefault();
        if(!manualProfile.first_name || !manualProfile.last_name || !manualProfile.email || !manualProfile.companyname) {
            alert("Veuillez remplir tous les champs obligatoires");
            return;
        }
        console.log('sending profile')
        console.log(manualProfile)
        await props.manualAddProfile(manualProfile);
        setAddingProfile(false);
    }

    function updateManualProfile(e) {
        const {name, value} = e.target;
        setManualProfile({...manualProfile, [name]:value});
    }

    function displayName(part) {
        return part?.hsCompany?.properties?.name || part?.user?.email;
    }

    function filename(part) {
        // replace any special characters with _
        return displayName(part).replace(/[^a-zA-Z0-9]/g, '_') + "__accord_confidentialite"
    }

    return (
        <div className='companies_cont'>
            {addingProfile && <Popup style={{maxWidth:'900px'}} close={() => setAddingProfile(false)}>
                <h2 className='centered'>Ajouter un profil</h2>
                <br/><br/>
                <b>Créer un candidat manuellement</b><br/><br/>
                <div className='dualInput'>
                    <label>
                        Prénom*<br/>
                        <input onChange={updateManualProfile} required type="text" name="first_name" placeholder='Prénom'/>
                    </label>
                    <label>
                        Nom*<br/>
                        <input onChange={updateManualProfile} required type="text" name="last_name" placeholder='Nom'/>
                    </label>
                </div>
                <div className='dualInput'>
                    <label>
                        Email*<br/>
                        <input onChange={updateManualProfile} required type="text" name="email" placeholder='Email'/>
                    </label>
                    <label>
                        Nom de l'entreprise*<br/>
                        <input onChange={updateManualProfile} required type="text" name="companyname" placeholder="Nom de l'entreprise"/>
                    </label>
                </div>
                <label>
                    Associer à une Shortlist - Sélectionnez une société (pop A)*<br/>
                    <select value={manualProfile.shortlistId} name="shortlistid" onChange={updateManualProfile}>
                        <option value="">Sélectionnez une entreprise</option>
                        {props.companies.map((part,i) => 
                            <option value={part.participation._id} key={i}>{part.hsProfile.company}</option>
                        )}
                    </select>
                </label>
                <br/>
                <button className='centered' onClick={addProfile}>Ajouter le profil</button>
            </Popup>}
            <button style={{alignSelf:"end", width:"fit-content"}} onClick={() => setAddingProfile(true)}>Ajouter un profil</button>
            Total : {props.participants.length}
            <div className='company_dsgn'>
                <p style={{flex:"3"}}></p>
                <p>Candidature(s)</p>
                <p>Shortlisté(s)</p>
            </div>
            {props.participants.sort((a,b) => displayName(a).localeCompare(displayName(b))).map((designer,i) => 
                <div key={i}>
                    <a href={"/admin/events/ficheadminpopb?eid=" + props.event._id + "&uid=" + designer.participation.userId} target="_blank"><div className='company_dsgn'>
                    
                        <b className='clickable' >{designer.participation.userId === "manual user" && <span className='thin tooltip'>ⓘ<span className="tooltiptext">Profil manuellement ajouté</span></span>}{displayName(designer)}</b>

                        <span className='thin tooltip'>
                            {designer.candidatures.filter(c => props.companies.find(part => part.participation._id === c.participationId)).length}
                            <span className="tooltiptext">Candidature(s)</span>
                        </span>
                        <span className='thin tooltip'>
                            {props.companies.filter(c => c.shortlist?.valide.includes(designer.participation._id)).length}
                            <span className="tooltiptext">Shortlist(s)</span>
                        </span>
                        <br/>
                        <MiniaturesContainer>
                            {/* {designer.portfolio?.map(pf =>
                                <div className='portfolio' key={pf._id}>
                                    {pf.files?.map((file,i) =>
                                        {
                                            if(i === 0 && file.uploaded_path && (file.mimetype === "image/jpeg" || file.mimetype === "image/png"))
                                            {
                                                return <img alt="" key={i} src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path}/>
                                            }
                                        }
                                    )}
                                </div>
                            )} */}
                            {designer.participation.data?.projets?.map((projet,i) =>
                                projet.files?.map((file,j) => {
                                    if(file.uploaded_path && (file.mimetype === "image/jpeg" || file.mimetype === "image/png")){
                                        return <img alt="" key={i+"_"+j} src={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + file.uploaded_path} style={{height:"100px", width:"auto"}}/>
                                    }else{
                                        return null;
                                    }
                                })
                            )}
                        </MiniaturesContainer>
                    </div></a>

                    
                    <button onClick={()=>{window.open("/profile?id=" + btoa(designer.user.email),"_blank")}}>Voir le profil</button>&nbsp;
                    <button onClick={()=>{window.open("/myprofile?id=" + btoa(designer.user.email),"_blank")}}>Modifier le profil</button>&nbsp;
                    {designer.company && <button onClick={()=>{window.open("/company?id=" + designer.company._id,"_blank")}}>Voir la société</button>}&nbsp;
                    <button onClick={()=>{window.open("/mycompany?id=" + btoa(designer.user.email),"_blank")}}>Modifier la société</button>&nbsp;
                    {designer.participation.data.confidentiality_agreement && <a download href={process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + designer.participation.data.confidentiality_agreement.uploaded_path + "?downloadfile=true&filename=" + filename(designer)} target="_blank" rel="noreferrer"><button className='accord_button'>Accord de confidentialité</button></a>}
                </div>
            )}
        </div>  
    );
};

export default DesignersList;